import { ValidationObserver, ValidationProvider } from 'vee-validate'

// register vee-validate components
const components = {
  install(Vue) {
    Vue.component('validation-observer', ValidationObserver)
    Vue.component('validation-provider', ValidationProvider)
  }
}

export default components
